import { _t } from '../../services/TranslationService.js';
let Error404 = {

    render : async () => {
        let view =  /*html*/`
            <section class="section">
                <h1> ${_t('404 Error')} </h1>
            </section>
        `
        return view
    }
    , after_render: async () => {
    }
}
export default Error404;